import { BNT_ASISTENTE_PATH } from "@/modules/asistente/bntAsistenteRoutes";
import { normalizeMainSystemPath } from "@/modules/asistente/bntAsistenteMessaging";

/** Rutas internas del sistema que no deben abrirse dentro del asistente. */
export function isBntAsistenteExternalPath(path) {
  const normalized = normalizeMainSystemPath(path);
  const pathOnly = String(normalized || "/").split("?")[0].split("#")[0];
  if (!pathOnly || pathOnly === "/") return true;
  return pathOnly !== BNT_ASISTENTE_PATH && !pathOnly.startsWith(`${BNT_ASISTENTE_PATH}/`);
}

/**
 * Intercepta clics en enlaces internos del asistente para abrir el módulo en pantalla completa.
 * @param {(path: string) => void} onOpenInMainSystem
 */
export function createBntAsistenteLinkCaptureHandler(onOpenInMainSystem) {
  if (typeof onOpenInMainSystem !== "function") return undefined;
  return (event) => {
    const anchor = event.target?.closest?.("a[href]");
    if (!anchor) return;
    if (anchor.target === "_blank" || anchor.hasAttribute("download")) return;

    const rawHref = String(anchor.getAttribute("href") || "").trim();
    if (!rawHref || rawHref.startsWith("#") || rawHref.startsWith("mailto:") || rawHref.startsWith("tel:")) {
      return;
    }

    let path = rawHref;
    if (/^https?:\/\//i.test(rawHref)) {
      try {
        const url = new URL(rawHref);
        if (url.origin !== window.location.origin) return;
        path = `${url.pathname}${url.search}${url.hash}`;
      } catch {
        return;
      }
    }

    if (!isBntAsistenteExternalPath(path)) return;
    event.preventDefault();
    event.stopPropagation();
    onOpenInMainSystem(path);
  };
}
